// src/components/auth/GuestRoute.tsx
// Inverse of PrivateRoute — redirects already-authenticated users away from
// guest-only pages (/login, /register) instead of showing the form again.

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ListTodo } from 'lucide-react';
import { RootState } from 'store';

interface Props {
  children: React.ReactElement;
}

export default function GuestRoute({ children }: Props) {
  const { isAuthenticated, isInitializing, user } = useSelector((s: RootState) => s.auth);

  // Still doing silent refresh on app mount — show nothing / spinner, same
  // as PrivateRoute, so guest pages don't flash before we know the session.
  if (isInitializing) {
    return (
      <div className="h-screen flex items-center justify-center bg-[var(--om-app)]">
        <div className="text-center">
          <div className="flex justify-center mb-3"><ListTodo className="w-7 h-7" strokeWidth={2} /></div>
          <div className="text-[var(--om-text-dim)] text-xs">Loading...</div>
        </div>
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to={user?.isAdmin ? '/admin' : '/'} replace />;
  }

  return children;
}
